import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Projects: React.FC = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const projects = [
    {
      title: "De Ponta Cabeça",
      description: "Blog de crônicas",
      image: "/images/de_ponta_cabeca.jpg",
      link: "/cases/de_ponta_cabeca.html"
    },
    {
      title: "VL!",
      description: "Acompanhamento de viagens em tempo real",
      image: "/images/vli.png",
      link: "/cases/vli.html",
      featured: true
    },
    {
      title: "Deborah Zandonna",
      description: "Blog de moda e consultoria de estilo",
      image: "/images/deborah_zandonna.png",
      link: "/cases/deborah_zandonna.html"
    },
    {
      title: "TMF",
      description: "Sistema de pesquisa e análise de mercado",
      image: "/images/tmf.png",
      link: "/cases/tmf.html"
    },
    {
      title: "Mundo dos Playgrounds",
      description: "E-commerce de brinquedos",
      image: "/images/mundo_dos_playgrounds.jpg",
      link: "/cases/mundo_dos_playgrounds.html"
    }
  ];

  return (
    <section id="projects" className="section-padding">
      <div ref={ref} className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-primary-600 mb-6">
            Nossos projetos
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`relative group cursor-pointer overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 ${
                project.featured ? 'md:row-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className="aspect-w-16 aspect-h-9 bg-gray-200">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
              </div>
              
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <h3 className="text-xl font-semibold font-heading mb-2">
                    {project.title}
                  </h3>
                  <p className="text-sm text-gray-200">
                    {project.description}
                  </p>
                  <div className="mt-4">
                    <span className="inline-flex items-center text-sm font-medium text-white">
                      Ver projeto
                      <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
